import styles from './settings-button.module.scss';

import { IconSettings } from '@lmig/lmds-react/icons';
import { useNavigate } from 'react-router-dom';

const SettingsButton = () => {
  const navigate = useNavigate();

  const navigateSettings = () => {
    navigate('/settings');
  };

  return (
    <button id="btn-settings" onClick={() => navigateSettings()} className={styles.settingsButton}>
      <div className={styles.settingsLogo}>
        <IconSettings size={'16'} title={'Settings'} />
      </div>
      <div className={styles.settingsText} data-testid='settings-label'>Settings</div>
    </button>
  );
};

export default SettingsButton;
